import { render, staticRenderFns } from "./ServiceInfo.vue?vue&type=template&id=3129e2f8&"
import script from "./ServiceInfo.vue?vue&type=script&lang=js&"
export * from "./ServiceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports